import React, { useEffect, useState } from "react";
import Seo from "../components/Seo";
import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import AnniversarySection from "../components/landing/AnniversarySection";
import {
  ProblemSection,
  SolutionSection,
} from "../components/landing/ProblemSolution";
import Portfolio from "../components/landing/Portfolio";
import HookSection from "../components/landing/HookSection";
import Pricing from "../components/landing/Pricing";
import AdvancedProjects from "../components/landing/AdvancedProjects";
import Process from "../components/landing/Process";
import Maintenance from "../components/landing/Maintenance";
import ContactForm from "../components/landing/ContactForm";
import FAQ from "../components/landing/FAQ";
import {
  FinalCTA,
  Footer,
} from "../components/landing/FinalCTAFooter";
import WhatsAppFloat from "../components/landing/WhatsAppFloat";
import WhatsAppLeadModal from "../components/landing/WhatsAppLeadModal";
import { NEXO_ENABLED } from "../config/bdk";

const Landing = () => {
  const [waHref, setWaHref] = useState(null);

  useEffect(() => {
    // Delegated listener: catches clicks on every WhatsApp link across the
    // page (float button, nav, hero, pricing CTAs, etc.) without wiring an
    // onClick into each section. Instead of navigating straight to wa.me, it
    // opens a lead-capture modal so the WhatsApp Lead event carries real
    // match data server-side too.
    const onClick = (e) => {
      const link = e.target.closest('a[href*="wa.me"]');
      // data-no-lead-modal opts a link out (e.g. the post-submit success
      // screen, where the visitor already gave us their data in the form).
      if (link && !link.hasAttribute("data-no-lead-modal")) {
        e.preventDefault();
        setWaHref(link.href);
      }
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  return (
    <div
      data-testid="landing-page"
      className="min-h-screen bg-white text-[#101010]"
    >
      <Seo
        title="Páginas Web Profesionales para Negocios | BDKSISTEMAS"
        description="Diseñamos y desarrollamos páginas web profesionales para negocios: landing pages, sitios empresariales, catálogos, reservaciones, tiendas en línea y proyectos a medida."
        path="/"
      />
      <Navbar />
      <main>
        <Hero />
        <AnniversarySection />
        <ProblemSection />
        <SolutionSection />
        <Pricing />
        <Portfolio />
        <HookSection />
        <Process />
        <AdvancedProjects />
        <ContactForm />
        <FAQ />
        {/* Maintenance (detalle post-venta) va después de FAQ para no
            interrumpir la ruta Páginas web → Proceso → Contacto. */}
        <Maintenance />
        <FinalCTA />
      </main>
      <Footer />
      {!NEXO_ENABLED && <WhatsAppFloat />}
      <WhatsAppLeadModal
        open={!!waHref}
        href={waHref}
        onClose={() => setWaHref(null)}
      />
    </div>
  );
};

export default Landing;
